// TODO: Remove this once the new framework is fully integrated
// biome-ignore lint/suspicious/noExplicitAny: TEMPORARY solution to convert the routes into new framework compatible routes
export function convertFrameworkRoute(m: any) {
	const { clientLoader, clientAction, default: Component, ...rest } = m;
	return {
		...rest,
		loader: clientLoader,
		action: clientAction,
		Component,
	};
}
